import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';

interface AIProcessStep {
  icon: string; // Bootstrap icon class
  title: string;
  description: string;
  duration?: string; // optional, can be used for timeline duration
}

@Component({
  selector: 'app-ai',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './ai.component.html',
  styleUrl: './ai.component.scss',
  encapsulation: ViewEncapsulation.None, // ✅ Make sure this line is here
})
export class AiComponent implements OnInit {
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private router: Router,
    private canonicalService: CanonicalService
  ) {}
  goToContact() {
    this.router.navigate(['/contact']);
  }
  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle(
      'AI Services | Intelligent Solutions by MALtech'
    );

    // Set meta description
    this.metaService.updateTag({
      name: 'description',
      content:
        'Maltech AI delivers cutting-edge Artificial Intelligence solutions—custom AI models, automation, and data-driven intelligence to transform businesses.',
    });

    // Set meta keywords
    this.metaService.updateTag({
      name: 'keywords',
      content:
        'Artificial Intelligence, AI Solutions, AI Development, AI Services, AI Automation, AI Consulting, Maltech AI',
    });

    // Optional: SEO enhancements
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });

    this.canonicalService.setCanonicalURL('service/ai/');
  }
  faqs = [
    {
      q: 'How can AI solutions from MALtech help my business?',
      a: 'AI helps automate processes, provide data-driven insights, enhance decision-making, and deliver personalized customer experiences ultimately improving efficiency, scalability, and business growth.',
    },
    {
      q: ' Does MALtech provide ongoing AI support?',
      a: ' Yes. We offer continuous monitoring, retraining of models, and technical support to ensure long-term performance.',
    },
    {
      q: 'What industries does MALtech serve with AI?',
      a: ' We serve industries such as Retail, Finance, Healthcare, Manufacturing, IT, Cybersecurity, and Education.',
    },
  ];
  openFaqIndex = -1;

  toggleFaq(i: number) {
    this.openFaqIndex = this.openFaqIndex === i ? -1 : i;
  }

  steps: AIProcessStep[] = [
    {
      icon: 'bi-search',
      title: 'Discovery & Consultation',
      description:
        'We understand your business goals and challenges to identify AI opportunities.',
    },
    {
      icon: 'bi-file-earmark-text',
      title: 'Data Collection & Preparation',
      description:
        'Gather, clean, and structure data to ensure high-quality input for AI models.',
    },
    {
      icon: 'bi-code-slash',
      title: 'Model Development',
      description:
        'Design and build AI models using appropriate algorithms and techniques.',
    },
    {
      icon: 'bi-check-circle',
      title: 'Testing & Validation',
      description:
        'Thoroughly test and validate models to ensure accuracy, reliability, and performance.',
    },
    {
      icon: 'bi-cloud-upload',
      title: 'Deployment & Support',
      description:
        'Deploy AI solutions into your environment and provide ongoing support and maintenance.',
    },
  ];

  getStart() {
    const plansSection = document.getElementById('get-start');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
